import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Response } from 'express';
import { of } from 'rxjs';
import { RESPONSE } from '../../express.tokens';
import { StateService } from '../services/state.service';

export const notFoundGuard: CanActivateFn = () => {
  const state = inject(StateService);
  const platformId = inject(PLATFORM_ID);
  const response = inject<Response>(RESPONSE, { optional: true });

  if (isPlatformServer(platformId)) response?.status(404);
  state.nextPageIsNotFound = true;
  return of(true);
};
